<svg width="3" height="20" viewBox="0 0 3 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect y="19.4678" width="19.4679" height="2.04925" transform="rotate(-90 0 19.4678)" fill="currentColor" />
</svg>
